"use strict";
'use strict';

const breakpoints = {
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
};

exports.breakpoints = breakpoints;
